import { Card, CardContent, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";
import styles from "./bonusOverviewStyles";

export default function BonusOverviewSkeleton() {
  return (
    <>
      <Grid container spacing={2}>
        {[0, 1, 2, 3].map((index) => (
          <Grid size={{ xs: 12, sm: 6, lg: 3 }} key={index}>
            <Card sx={[styles.card, index === 0 && styles.progress]}>
              <CardContent sx={styles.cardContent}>
                <Stack spacing={1}>
                  <Typography variant="h5"><Skeleton animation="wave" width="85%" /></Typography>
                  <Typography variant="h1"><Skeleton animation="wave" width="55%" /></Typography>
                  <Typography variant="body2"><Skeleton animation="wave" /></Typography>
                  <Divider />
                  <Typography variant="body2"><Skeleton animation="wave" width="75%" /></Typography>
                  <Typography variant="body2"><Skeleton animation="wave" width="60%" /></Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Card sx={styles.chartCard}>
        <Typography variant="h2" component="h2" sx={styles.chartHeading}><Skeleton animation="wave" width="20rem" /></Typography>
        <Skeleton animation="wave" variant="rounded" height="28rem" />
      </Card>
    </>
  );
}
